import { DataTableCellLastUpdate } from './components/Cells';
import DataTableCell from './components/Cells/DataTableCell';
import DataTableCellDate from './components/Cells/DataTableCellDate';
import DataTableCellDriver from './components/Cells/DataTableCellDriver';
import DataTableCellDriverPhoto from './components/Cells/DataTableCellDriverPhoto';
import DataTableCellFuel from './components/Cells/DataTableCellFuel';
import DataTableCellLicensePlate from './components/Cells/DataTableCellLicensePlate';
import DataTableCellSafetyOccurrences from './components/Cells/DataTableCellSafetyOccurrences';
import DataTableCellSafetyReviewStatus from './components/Cells/DataTableCellSafetyReviewStatus';
import DataTableCellVehicle from './components/Cells/DataTableCellVehicle';
import DataTableCellVehicleGroups from './components/Cells/DataTableCellVehicleGroups';
import DataTableCellVehicleTags from './components/Cells/DataTableCellVehicleTags';
import DataTableAction from './components/DataTableAction';
import DataTableActions from './components/DataTableActions';
import DataTableExport from './components/DataTableExport';
import DataTableHeader from './components/DataTableHeader';
import DataTablePagination from './components/DataTablePagination';
import type { ExportDef } from './components/Export';
import {
  FiltersDef,
  filterGetParamColumns,
  filterGetParamDates,
  filterGetParamFilters,
  filterGetParamPagination,
  filterGetParamSearch,
  filterSetParamColumns,
  filterSetParamDates,
  filterSetParamFilters,
  filterSetParamPagination,
  filterSetParamSearch,
} from './components/Filters';
import DataTable, { type DataTableProps, type SortingState, type VisibilityState } from './DataTable';
import type { IFiltersDef, TFilterKeys } from './types';

export type { DataTableProps, ExportDef, SortingState, VisibilityState };

export type {
  CreateFiltersProps,
  FiltersProps,
  IFiltersDef,
  TFilterKeys,
  TFilterParamsKeys,
} from './types';

const filterGetByKeys = (keys: TFilterKeys[]): IFiltersDef[] => {
  const filters = filterGetParamFilters();
  return keys.map((key) => filters.find((f) => f.key === key)) as IFiltersDef[];
};

export {
  DataTableAction,
  DataTableExport,
  DataTableHeader,
  DataTablePagination,
  DataTableActions,
  DataTableCell,
  DataTableCellDriver,
  DataTableCellDriverPhoto,
  DataTableCellFuel,
  DataTableCellLicensePlate,
  DataTableCellVehicle,
  DataTableCellVehicleGroups,
  DataTableCellVehicleTags,
  DataTableCellDate,
  DataTableCellSafetyOccurrences,
  DataTableCellSafetyReviewStatus,
  DataTableCellLastUpdate,
  filterGetByKeys,
  filterGetParamColumns,
  filterGetParamDates,
  filterGetParamFilters,
  filterGetParamPagination,
  filterGetParamSearch,
  FiltersDef,
  filterSetParamColumns,
  filterSetParamDates,
  filterSetParamFilters,
  filterSetParamPagination,
  filterSetParamSearch,
};

export default DataTable;
